module.exports = __webpack_public_path__ + "static/media/toolbar-menu.4f220f6c.svg";